
import api from './api';

class Product {

	constructor (Api) {
		this.Api = Api;
	}
	
	all(query){
		return this.Api.get({
			url:  'v1.1/m/products',
			query, 
		}).then(response => response.result);
	}
	
	ratings (productId) {
		return this.Api.get({
			url:  'v1.1/m/products/'+productId+'/ratings'
		}).then(response => response.result);
	}

}

Product.$inject = ['Api'];

export default angular.module('service.product', [api])
	.service('Product', Product)
	.name;



// WEBPACK FOOTER //
// ./src/service/product.js